export const moneyFormat = (suffix, thousands, decimal, precision) => ({
  prefix: suffix,
  thousands: thousands,
  decimal: decimal,
  precision: precision
})
